import { UnionResource } from 'api/resource'

class ConfigApi extends UnionResource {
  constructor() {
    super('client-config')
  }
}

export default ConfigApi
